export const oddsData = {
    "Georgia": { "odds": 98, "resume": 100, "record": "11.7-1.2", "value": 84 },
    "Notre Dame": { "odds": 98, "resume": 94, "record": "11.1-0.9", "value": 82 },
    "Miami": { "odds": 97, "resume": 95, "record": "11.7-1.3", "value": 80 },
    "Indiana": { "odds": 95, "resume": 96, "record": "11.1-1.5", "value": 77 },
    "Ohio State": { "odds": 86, "resume": 90, "record": "10.1-2.6", "value": 75 },
    "Utah": { "odds": 81, "resume": 86, "record": "11.0-1.7", "value": 74 },
    "Alabama": { "odds": 81, "resume": 87, "record": "10.0-2.5", "value": 74 },
    "Texas Tech": { "odds": 71, "resume": 81, "record": "10.7-1.9", "value": 76 },
    "UCLA": { "odds": 67, "resume": 80, "record": "10.2-2.1", "value": 72 },
    "Texas": { "odds": 57, "resume": 78, "record": "9.2-3.0", "value": 75 },
    "BYU": { "odds": 54, "resume": 74, "record": "9.8-2.6", "value": 74 },
    "Boise State": { "odds": 38, "resume": 64, "record": "10.7-2.3", "value": 63 },
    "James Madison": { "odds": 32, "resume": 59, "record": "11.9-1.0", "value": 64 },
    "LSU": { "odds": 22, "resume": 63, "record": "8.2-3.9", "value": 58 },
    "Missouri": { "odds": 18, "resume": 63, "record": "8.4-3.7", "value": 69 },
    "Nebraska": { "odds": 17, "resume": 64, "record": "8.7-3.4", "value": 68 },
    "Tennessee": { "odds": 17, "resume": 63, "record": "8.5-3.5", "value": 66 },
    "Iowa": { "odds": 17, "resume": 61, "record": "8.5-3.5", "value": 67 },
    "Ole Miss": { "odds": 14, "resume": 59, "record": "8.0-4.1", "value": 63 },
    "Houston": { "odds": 14, "resume": 62, "record": "8.9-3.1", "value": 50 },
    "Memphis": { "odds": 14, "resume": 53, "record": "10.1-2.7", "value": 62 },
    "Northwestern": { "odds": 14, "resume": 61, "record": "8.4-3.6", "value": 61 },
    "Wisconsin": { "odds": 13, "resume": 58, "record": "8.5-3.6", "value": 65 },
    "Wake Forest": { "odds": 11, "resume": 60, "record": "9.2-3.0", "value": 60 },
    "Oregon": { "odds": 10, "resume": 58, "record": "7.8-4.3", "value": 59 },
    "SMU": { "odds": 8, "resume": 53, "record": "8.6-3.8", "value": 54 },
    "Oklahoma State": { "odds": 7, "resume": 51, "record": "8.2-3.9", "value": 57 },
    "Mississippi State": { "odds": 6, "resume": 54, "record": "7.8-4.2", "value": 61 },
    "New Mexico": { "odds": 4, "resume": 46, "record": "10.3-2.5", "value": 61 },
    "Liberty": { "odds": 4, "resume": 50, "record": "11.2-1.8", "value": 55 },
    "Arizona": { "odds": 4, "resume": 51, "record": "8.3-3.8", "value": 59 },
    "USC": { "odds": 4, "resume": 53, "record": "8.0-4.0", "value": 63 },
    "Baylor": { "odds": 4, "resume": 45, "record": "7.7-4.4", "value": 39 },
    "Oregon State": { "odds": 3, "resume": 39, "record": "8.6-4.2", "value": 54 },
    "Kentucky": { "odds": 3, "resume": 49, "record": "7.6-4.5", "value": 40 },
    "Pittsburgh": { "odds": 3, "resume": 49, "record": "8.4-3.7", "value": 52 },
    "Louisville": { "odds": 2, "resume": 40, "record": "7.4-4.7", "value": 52 },
    "UTSA": { "odds": 2, "resume": 39, "record": "9.0-3.5", "value": 52 },
    "Oklahoma": { "odds": 2, "resume": 43, "record": "6.7-5.4", "value": 39 },
    "North Dakota State": { "odds": 2, "resume": 43, "record": "10.3-2.5", "value": 44 },
    "Duke": { "odds": 1, "resume": 40, "record": "7.7-4.3", "value": 49 },
    "Virginia": { "odds": 1, "resume": 29, "record": "6.9-5.2", "value": 51 },
    "Fresno State": { "odds": 1, "resume": 34, "record": "8.2-4.0", "value": 40 },
    "Florida": { "odds": 1, "resume": 42, "record": "6.8-5.2", "value": 44 },
    "Virginia Tech": { "odds": 1, "resume": 35, "record": "7.3-4.8", "value": 40 },
    "Michigan": { "odds": 1, "resume": 36, "record": "6.3-5.7", "value": 43 },
    "Penn State": { "odds": 1, "resume": 36, "record": "6.9-5.1", "value": 48 },
    "Clemson": { "odds": 1, "resume": 30, "record": "6.9-5.2", "value": 49 },
    "North Carolina": { "odds": 1, "resume": 29, "record": "6.5-5.5", "value": 44 },
    "North Texas": { "odds": 1, "resume": 24, "record": "7.7-4.5", "value": 43 },
    "Auburn": { "odds": 1, "resume": 32, "record": "5.9-6.1", "value": 43 },
    "Air Force": { "odds": 1, "resume": 22, "record": "8.6-3.5", "value": 42 },
    "Purdue": { "odds": 1, "resume": 19, "record": "5.1-6.9", "value": 42 },
    "Florida State": { "odds": 1, "resume": 21, "record": "5.8-6.2", "value": 51 },
    "UCF": { "odds": 1, "resume": 21, "record": "5.9-6.1", "value": 48 },
    "Kansas State": { "odds": 1, "resume": 32, "record": "6.9-5.1", "value": 40 },
    "South Carolina": { "odds": 1, "resume": 29, "record": "5.7-6.3", "value": 33 },
    "Texas A&M": { "odds": 1, "resume": 26, "record": "5.5-6.5", "value": 35 },
    "Florida Atlantic": { "odds": 1, "resume": 25, "record": "7.8-4.3", "value": 35 },
    "South Florida": { "odds": 1, "resume": 24, "record": "7.7-4.3", "value": 35 },
    "Cincinnati": { "odds": 1, "resume": 24, "record": "6.2-5.8", "value": 35 },
    "Minnesota": { "odds": 1, "resume": 24, "record": "5.6-6.4", "value": 39 },
    "Western Michigan": { "odds": 1, "resume": 18, "record": "8.8-3.9", "value": 37 },
    "Washington": { "odds": 1, "resume": 16, "record": "5.0-7.0", "value": 32 },
    "East Carolina": { "odds": 1, "resume": 16, "record": "7.0-5.2", "value": 25 },
    "Illinois": { "odds": 1, "resume": 16, "record": "4.8-7.2", "value": 43 },
    "Arizona State": { "odds": 1, "resume": 15, "record": "5.3-6.7", "value": 38 },
    "TCU": { "odds": 1, "resume": 15, "record": "5.0-7.0", "value": 29 },
    "UNLV": { "odds": 1, "resume": 14, "record": "7.9-4.4", "value": 36 },
    "Iowa State": { "odds": 1, "resume": 14, "record": "5.2-6.8", "value": 35 },
    "Kansas": { "odds": 1, "resume": 14, "record": "5.0-7.0", "value": 34 },
    "Georgia State": { "odds": 1, "resume": 14, "record": "8.1-4.0", "value": 33 },
    "UConn": { "odds": 1, "resume": 13, "record": "6.2-5.8", "value": 32 },
    "Toledo": { "odds": 1, "resume": 13, "record": "8.3-4.0", "value": 21 },
    "California": { "odds": 1, "resume": 7, "record": "5.2-6.8", "value": 33 },
    "Army": { "odds": 1, "resume": 12, "record": "6.7-5.4", "value": 24 },
    "Ohio": { "odds": 1, "resume": 12, "record": "8.5-4.1", "value": 17 },
    "Jacksonville State": { "odds": 1, "resume": 12, "record": "8.4-4.4", "value": 37 },
    "Vanderbilt": { "odds": 1, "resume": 11, "record": "4.5-7.5", "value": 24 },
    "NC State": { "odds": 1, "resume": 11, "record": "5.7-6.4", "value": 24 },
    "Texas State": { "odds": 1, "resume": 6, "record": "5.8-6.3", "value": 31 },
    "Michigan State": { "odds": 1, "resume": 5, "record": "3.8-8.2", "value": 31 },
    "Louisiana Tech": { "odds": 1, "resume": 5, "record": "7.4-4.6", "value": 22 },
    "Louisiana": { "odds": 1, "resume": 11, "record": "8.2-4.3", "value": 28 },
    "West Virginia": { "odds": 1, "resume": 3, "record": "4.4-7.6", "value": 17 },
    "Navy": { "odds": 1, "resume": 2, "record": "5.4-6.6", "value": 26 },
    "Tulsa": { "odds": 1, "resume": 5, "record": "6.1-5.9", "value": 20 },
    "Maryland": { "odds": 1, "resume": 0, "record": "3.9-8.1", "value": 29 },
    "Florida International": { "odds": 1, "resume": 0, "record": "7.2-5.0", "value": 30 },
    "Syracuse": { "odds": 1, "resume": 0, "record": "4.2-7.8", "value": 28 },
    "Tulane": { "odds": 1, "resume": 0, "record": "5.5-6.5", "value": 27 },
    "Colorado": { "odds": 1, "resume": 0, "record": "3.8-8.2", "value": 29 },
    "Georgia Tech": { "odds": 1, "resume": 0, "record": "4.0-8.0", "value": 19 },
    "Arkansas": { "odds": 1, "resume": 0, "record": "3.1-8.9", "value": 21 },
    "South Alabama": { "odds": 1, "resume": 0, "record": "7.1-5.2", "value": 23 },
    "Boston College": { "odds": 1, "resume": 0, "record": "3.6-8.4", "value": 19 },
    "Troy": { "odds": 1, "resume": 0, "record": "6.4-5.7", "value": 17 },
    "Temple": { "odds": 1, "resume": 0, "record": "5.1-7.0", "value": 16 },
    "Miami (OH)": { "odds": 1, "resume": 0, "record": "6.6-5.5", "value": 16 },
    "App State": { "odds": 1, "resume": 0, "record": "6.5-5.5", "value": 15 },
    "Buffalo": { "odds": 1, "resume": 0, "record": "6.7-5.5", "value": 14 },
    "UAB": { "odds": 1, "resume": 0, "record": "5.1-6.9", "value": 11 },
    "Georgia Southern": { "odds": 1, "resume": 0, "record": "5.7-6.3", "value": 12 },
    "Eastern Michigan": { "odds": 1, "resume": 0, "record": "6.2-5.9", "value": 11 },
    "Massachusetts": { "odds": 1, "resume": 0, "record": "7.2-4.8", "value": 7 },
    "San Diego State": { "odds": 1, "resume": 0, "record": "4.1-7.9", "value": 6 },
    "Colorado State": { "odds": 1, "resume": 0, "record": "4.2-7.8", "value": 15 },
    "Stanford": { "odds": 1, "resume": 0, "record": "3.3-8.7", "value": 21 },
    "Central Michigan": { "odds": 1, "resume": 0, "record": "5.9-6.1", "value": 6 },
    "Utah State": { "odds": 1, "resume": 0, "record": "3.9-8.1", "value": 5 },
    "Nevada": { "odds": 1, "resume": 0, "record": "5.1-6.9", "value": 5 },
    "Rutgers": { "odds": 1, "resume": 0, "record": "2.2-9.8", "value": 4 },
    "Arkansas State": { "odds": 1, "resume": 0, "record": "5.3-6.7", "value": 4 },
    "Delaware": { "odds": 1, "resume": 0, "record": "5.4-6.6", "value": 5 },
    "Old Dominion": { "odds": 1, "resume": 0, "record": "4.9-7.1", "value": 3 },
    "Wyoming": { "odds": 1, "resume": 0, "record": "5.1-6.9", "value": 1 },
    "San José State": { "odds": 1, "resume": 0, "record": "5.4-7.6", "value": 1 },
    "Kennesaw State": { "odds": 1, "resume": 0, "record": "4.5-7.5", "value": 0 },
    "Washington State": { "odds": 1, "resume": 0, "record": "2.7-9.3", "value": 0 },
    "Coastal Carolina": { "odds": 1, "resume": 0, "record": "4.1-7.9", "value": 0 },
    "Marshall": { "odds": 1, "resume": 0, "record": "5.3-6.7", "value": 0 },
    "Rice": { "odds": 1, "resume": 0, "record": "2.7-9.3", "value": 0 },
    "Bowling Green": { "odds": 1, "resume": 0, "record": "4.3-7.7", "value": 0 },
    "Middle Tennessee": { "odds": 1, "resume": 0, "record": "4.3-7.7", "value": 0 },
    "Hawai'i": { "odds": 1, "resume": 0, "record": "3.8-8.2", "value": 0 },
    "New Mexico State": { "odds": 1, "resume": 0, "record": "4.5-7.5", "value": 0 },
    "Western Kentucky": { "odds": 1, "resume": 0, "record": "4.5-7.5", "value": 0 },
    "Sam Houston": { "odds": 1, "resume": 0, "record": "4.0-8.0", "value": 0 },
    "Kent State": { "odds": 1, "resume": 0, "record": "4.0-8.0", "value": 0 },
    "Missouri State": { "odds": 1, "resume": 0, "record": "3.0-9.0", "value": 0 },
    "Southern Miss": { "odds": 1, "resume": 0, "record": "2.9-9.1", "value": 0 },
    "Ball State": { "odds": 1, "resume": 0, "record": "2.8-9.2", "value": 0 },
    "Akron": { "odds": 1, "resume": 0, "record": "2.5-9.5", "value": 0 },
    "UTEP": { "odds": 1, "resume": 0, "record": "2.3-9.7", "value": 0 },
    "Sacramento State": { "odds": 1, "resume": 0, "record": "2.5-9.5", "value": 0 },
    "Northern Illinois": { "odds": 1, "resume": 0, "record": "1.5-10.5", "value": 0 },
    "Charlotte": { "odds": 1, "resume": 0, "record": "0.5-11.5", "value": 0 },
    "UL Monroe": { "odds": 1, "resume": 0, "record": "1.2-10.8", "value": 0 },

}